import React from "react";

// Small eyebrow + heading block used across sections
const SectionHeading = ({ tag, title, desc, light = false, center = false }) => {
  return (
    <div className={`${center ? "text-center mx-auto max-w-3xl" : "max-w-2xl"}`}>
      {tag && (
        <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-amber-500">
          <span className="w-6 h-px bg-amber-500" />
          {tag}
        </span>
      )}
      <h2
        className={`mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] ${
          light ? "text-white" : "text-navy-900"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-5 text-base sm:text-lg leading-relaxed ${
            light ? "text-slate-300" : "text-slate-600"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
